import { AvatarScreen } from "../../features/home";

/** FS-01-03 아바타 선택 — 페이지는 조립만 한다(CSG 4.2). 화면 본체는 features/home */
export default function AvatarPage() {
  return <AvatarScreen />;
}
